import React from 'react';
import { CountdownTimer } from './CountdownTimer';
const offer = {
  emoji: '🏆',
  title: 'FÚTBOL LISTO 360™',
  description: '6 Volúmenes + 5 Bonos',
  originalPrice: '$67 USD',
  price: '22',
  currency: '$',
  ctaText: '🚀 QUIERO FÚTBOL LISTO 360 AHORA',
  ctaHref: 'https://calcio-giovanile-pronto.impultienda.ar/checkout',
  savings: 'AHORRÁS $45'
};
const includes = ['6 Volúmenes Completos', '250 Páginas de Contenido', '101 Ejercicios Técnicos', '5 Bonos Estratégicos', 'Acceso Inmediato', 'Acceso de por Vida'];
export function PricingSection() {
  return <section id="pricing" className="w-full bg-white py-16 sm:py-24 px-4" data-id="element-125">
      <div className="max-w-xl mx-auto" data-id="element-126">
        <div className="text-center mb-10" data-id="element-127">
          <h2 className="text-3xl sm:text-5xl font-black text-[#0A0A0A] mb-3 tracking-tight" data-id="element-128">
            Todo incluido,{' '}
            <span className="text-[#00A650]" data-id="element-129">un solo precio.</span>
          </h2>
          <p className="text-[#5A5A66] text-sm sm:text-base font-bold" data-id="element-130">
            Paquete completo. Sin upsells. Sin sorpresas.
          </p>
        </div>

        <div className="relative bg-white border-2 border-[#00A650] rounded-3xl pt-10 px-6 sm:px-10 pb-8 sm:pb-10 shadow-xl mb-6 text-center" data-id="element-131">
          {/* Centered top ribbon */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#00A650] text-white text-[10px] sm:text-xs font-black px-5 py-2 rounded-full uppercase tracking-widest shadow-lg whitespace-nowrap" data-id="element-132">
            🏆 KIT ESTRATÉGICO
          </div>

          {/* Title */}
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-133">
            <span className="text-2xl sm:text-3xl" data-id="element-134">{offer.emoji}</span>
            <span className="text-[#0A0A0A] font-black text-lg sm:text-2xl tracking-tight" data-id="element-135">
              {offer.title}
            </span>
          </div>
          <p className="text-[#5A5A66] text-sm sm:text-base font-semibold mb-7" data-id="element-136">
            {offer.description}
          </p>

          {/* Price block — centered */}
          <div className="mb-7 pb-7 border-b border-[#E5E5EA]" data-id="element-137">
            <div className="text-[#5A5A66] line-through text-base font-bold mb-2" data-id="element-138">
              Precio original: {offer.originalPrice}
            </div>
            <div className="flex items-start justify-center gap-1 mb-3" data-id="element-139">
              <span className="font-black text-3xl sm:text-4xl text-[#0A0A0A] mt-2 sm:mt-3" data-id="element-140">
                {offer.currency}
              </span>
              <span className="font-black text-7xl sm:text-8xl text-[#0A0A0A] tracking-tighter leading-none" data-id="element-141">
                {offer.price}
              </span>
              <span className="font-black text-lg sm:text-xl text-[#0A0A0A] mt-3 sm:mt-4 ml-1" data-id="element-142">
                USD
              </span>
            </div>
            <span className="inline-block bg-[#00A650] text-white text-xs font-black px-4 py-2 rounded-full uppercase tracking-widest shadow-md" data-id="element-143">
              {offer.savings}
            </span>
          </div>

          {/* Includes label */}
          <p className="text-[#0A0A0A] text-xs font-black uppercase tracking-widest mb-5" data-id="element-144">
            Qué incluye
          </p>

          {/* Includes grid — centered */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 max-w-md mx-auto text-left" data-id="element-145">
            {includes.map(item => <div key={item} className="flex items-center gap-2.5" data-id="element-146">
                <span className="text-[#00A650] text-base flex-shrink-0" data-id="element-147">
                  ✅
                </span>
                <span className="text-[#0A0A0A] text-sm font-semibold" data-id="element-148">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        <div className="flex items-center justify-center gap-3 mb-6 bg-[#FAFAFA] py-3 rounded-xl border border-[#E5E5EA]" data-id="element-149">
          <span className="text-[#0A0A0A] text-xs sm:text-sm font-black uppercase tracking-wider" data-id="element-150">
            ⏰ Termina en
          </span>
          <CountdownTimer size="sm" blinking={false} data-id="element-151" />
        </div>

        <a href="https://futbollisto360.impultienda.ar/checkout" className="btn-cta-green block w-full text-center font-black text-lg sm:text-xl py-5 rounded-2xl transition-colors shadow-lg mb-4" data-id="element-152">
          {offer.ctaText}
        </a>

        <p className="text-[#5A5A66] text-xs text-center mb-6 font-semibold" data-id="element-153">
          💱 Pagarás en tu moneda local
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs sm:text-sm text-[#5A5A66] font-bold" data-id="element-154">
          <span className="flex items-center gap-1.5" data-id="element-155">🔒 Pago Seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-156">⚡ Acceso en 5 min</span>
          <span className="flex items-center gap-1.5" data-id="element-157">🛡️ Garantía 7 Días</span>
          <span className="flex items-center gap-1.5" data-id="element-158">
            💳 Tarjeta · ApplePay · GooglePay
          </span>
        </div>
      </div>
    </section>;
}